import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseGeneralPages() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validateContent(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      content: isEmpty(state.content),
    };

    setter(errorState);

    if (errorState.title || errorState.content) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validateContact(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      content: isEmpty(state.content),
      type: isEmpty(state.type),
    };

    setter(errorState);

    if (errorState.title || errorState.content || errorState.type) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validateFAQ(state, setter) {
    let errorState = {
      answer: isEmpty(state.answer),
      question: isEmpty(state.question),
    };

    setter(errorState);

    if (errorState.answer || errorState.question) {
      enqueueSnackbar("لطفا پرسش و پاسخ را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetGeneralPages = (bool, callback) => {
    MyAxios.get(`Admin_GeneralPages`, {
      headers: {
        IsPage: bool ? true : false,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetGeneralPagesByID = (Id, callback) => {
    MyAxios.get(`Admin_GeneralPages/${Id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateGeneralPage = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_GeneralPages`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش صفحه باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  // /////////////////////////////////////           content               ///////////////////////////////////////////////////

  const DeletePageContent = (ContentID, callback) => {
    const data = new FormData();
    data.append("ContentID", ContentID);
    MyAxios.delete(`Admin_GeneralPages/Content`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const UpdatePageContent = (Model, Icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (Icon) {
      data.append("Icon", Icon);
    } else {
      data.append("Icon", "-");
    }
    MyAxios.put(`Admin_GeneralPages/Content`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش محتوا باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddPageContent = (Model, Icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (Icon) {
      data.append("Icon", Icon);
    } else {
      data.append("Icon", "-");
    }
    MyAxios.post(`Admin_GeneralPages/Content`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن محتوا باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddContentImage = (Model, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    data.append("Image", file);
    MyAxios.post(`Admin_GeneralPages/Image`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن تصویر باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteContentImage = (ImageID, callback) => {
    const data = new FormData();
    data.append("ImageID", ImageID);
    MyAxios.delete(`Admin_GeneralPages/Image`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف تصویر باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  ///////////////////////////////////////            Contact               ///////////////////////////////////////////////////

  const DeletePageContact = (ContactID, callback) => {
    const data = new FormData();
    data.append("ContactID", ContactID);
    MyAxios.delete(`Admin_GeneralPages/Contact`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const UpdatePageContact = (Model, Icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (Icon) {
      data.append("Icon", Icon);
    } else {
      data.append("Icon", "-");
    }
    MyAxios.put(`Admin_GeneralPages/Contact`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش اطلاعات باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddPageContact = (Model, Icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (Icon) {
      data.append("Icon", Icon);
    } else {
      data.append("Icon", "-");
    }
    MyAxios.post(`Admin_GeneralPages/Contact`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن اطلاعات باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };
  ///////////////////////////////////////            FAQ               ///////////////////////////////////////////////////

  const DeletePageFAQ = (FAQID, callback) => {
    const data = new FormData();
    data.append("FAQID", FAQID);
    MyAxios.delete(`Admin_GeneralPages/faq`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  const UpdatePageFAQ = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.put(`Admin_GeneralPages/faq`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش پرسش و پاسخ باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddPageFAQ = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_GeneralPages/faq`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن پرسش و پاسخ باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  return {
    GetGeneralPages,
    validateContent,
    GetGeneralPagesByID,
    UpdateGeneralPage,
    DeletePageContent,
    UpdatePageContent,
    AddPageContent,
    AddContentImage,
    DeleteContentImage,
    DeletePageContact,
    UpdatePageContact,
    AddPageContact,
    validateContact,
    DeletePageFAQ,
    UpdatePageFAQ,
    AddPageFAQ,
    validateFAQ,
  };
}
